module.exports = __webpack_public_path__ + "img/lock.3980e514.svg";